//Parroquia Tachira
const munAndrésBelloTachira = ['Andrés Bello'];
const munAntonioRómuloCosta = ['Antonio Rómulo Costa'];
const munAyacucho = ['Ayacucho', 'Rivas Berti', 'San Pedro del Río'];
const munBolívarTachira = [
  'Bolívar',
  'Palotal',
  'Juan Vicente Gómez',
  'Isaías Medina Angarita',
];
const munCárdenas = ['Cárdenas', 'Amenodoro Rangel Lamús', 'La Florida'];
const munCórdoba = ['Córdoba'];
const munFernándezFeo = ['Fernández Feo', 'Alberto Adriani', 'Santo Domingo'];
const munFranciscodeMiranda = ['San José De Bolívar'];
const munGarcíadeHevia = [
  'García de Hevia',
  'Boca de Grita',
  'José Antonio Páez',
];
const munGuásimos = ['Guásimos'];
const munIndependenciaTachira = [
  'Independencia',
  'Juan Germán Roscio',
  'Román Cárdenas',
];
const munJáuregui = [
  'Jáuregui',
  'Emilio Constantino Guerrero',
  'Monseñor Miguel Antonio Salas',
];
const munJoséMaríaVargas = ['Vargas'];
const munJunín = ['Junín', 'La Petrólea', 'Quinimarí', 'Bramón'];
const munLibertadTachira = [
  'Libertad',
  'Cipriano Castro',
  'Manuel Felipe Rugeles',
];
const munLibertadorTachira = [
  'Libertador',
  'Don Emeterio Ochoa',
  'Doradas',
  'San Joaquín de Navay',
];
const munLobatera = ['Lobatera', 'Constitución'];
const munMichelena = ['Michelena'];
const munPanamericano = ['Panamericano', 'La Palmita'];
const munPedroMaríaUreña = ['Pedro María Ureña', 'Nueva Arcadia'];
const munRafaelUrdaneta = ['Delicias'];
const munSamuelDaríoMaldonado = [
  'Samuel Darío Maldonado',
  'Boconó ',
  'Hernández',
];
const munSanCristóbal = [
  'La Concordia',
  'Pedro María Morantes',
  'San Juan Bautista',
  'San Sebastián',
  'Dr Francisco Romero Lobo',
];
const munSeboruco = ['Seboruco'];
const munSimónRodríguez = ['San Simón'];
const munSucreTachira = ['Sucre', 'Eleazar López Contreras', 'San Pablo'];
const munTorbes = [
  'Torbes',
  'Pedro María Morantes',
  'San Juan Bautista',
  'San Sebastián',
  'Dr Francisco Romero Lobo',
];
const munUribante = ['Uribante', 'Cárdenas', 'Juan Pablo Peñaloza', 'Potosí'];
const munSanJudasTadeo = ['San Judas Tadeo '];

export const esTachira = [
  {
    municipio: 'Andrés Bello',
    parroquias: munAndrésBelloTachira,
  },
  {
    municipio: 'Antonio Rómulo Costa',
    parroquias: munAntonioRómuloCosta,
  },
  {
    municipio: 'Ayacucho',
    parroquias: munAyacucho,
  },
  {
    municipio: 'Bolívar',
    parroquias: munBolívarTachira,
  },
  {
    municipio: 'Cárdenas',
    parroquias: munCárdenas,
  },
  {
    municipio: 'Córdoba',
    parroquias: munCórdoba,
  },
  {
    municipio: 'Fernández Feo',
    parroquias: munFernándezFeo,
  },
  {
    municipio: 'Francisco De Miranda',
    parroquias: munFranciscodeMiranda,
  },
  {
    municipio: 'García de Hevia',
    parroquias: munGarcíadeHevia,
  },
  {
    municipio: 'Guásimos',
    parroquias: munGuásimos,
  },
  {
    municipio: 'Jáuregui',
    parroquias: munJáuregui,
  },
  {
    municipio: 'Independencia',
    parroquias: munIndependenciaTachira,
  },
  {
    municipio: 'José María Vargas',
    parroquias: munJoséMaríaVargas,
  },
  {
    municipio: 'Junín',
    parroquias: munJunín,
  },
  {
    municipio: 'Libertad',
    parroquias: munLibertadTachira,
  },
  {
    municipio: 'Libertador',
    parroquias: munLibertadorTachira,
  },
  {
    municipio: 'Lobatera',
    parroquias: munLobatera,
  },
  {
    municipio: 'Michelena',
    parroquias: munMichelena,
  },
  {
    municipio: 'Panamericano',
    parroquias: munPanamericano,
  },
  {
    municipio: 'Pedro María Ureña',
    parroquias: munPedroMaríaUreña,
  },
  {
    municipio: 'Rafael Urdaneta',
    parroquias: munRafaelUrdaneta,
  },
  {
    municipio: 'Samuel Darío Maldonado',
    parroquias: munSamuelDaríoMaldonado,
  },
  {
    municipio: 'San Cristóbal',
    parroquias: munSanCristóbal,
  },
  {
    municipio: 'Seboruco',
    parroquias: munSeboruco,
  },
  {
    municipio: 'Simón Rodríguez',
    parroquias: munSimónRodríguez,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreTachira,
  },
  {
    municipio: 'Torbes',
    parroquias: munTorbes,
  },
  {
    municipio: 'Uribante',
    parroquias: munUribante,
  },
  {
    municipio: 'San Judas Tadeo',
    parroquias: munSanJudasTadeo,
  },
];
